// React
import { createContext } from "react"

export const DataContext = createContext<{
  created_by: number
}>({
  created_by: 0
})